/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    GetServiceIntervalsParams,
    ServiceIntervalBatchResponse,
    ServiceIntervalBatchUpdateRequest
} from '../models';

export type getServiceIntervalsResponse200 = {
    data: ServiceIntervalBatchResponse;
    status: 200;
};

export type getServiceIntervalsResponse400 = {
    data: void;
    status: 400;
};

export type getServiceIntervalsResponse500 = {
    data: void;
    status: 500;
};

export type getServiceIntervalsResponseSuccess = getServiceIntervalsResponse200 & {
    headers: Headers;
};

export type getServiceIntervalsResponseError = (
    | getServiceIntervalsResponse400
    | getServiceIntervalsResponse500
) & {
    headers: Headers;
};

export type getServiceIntervalsResponse =
    | getServiceIntervalsResponseSuccess
    | getServiceIntervalsResponseError;

export const getGetServiceIntervalsUrl = (params: GetServiceIntervalsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/service-intervals?${stringifiedParams}`
        : `/api/v1/service-intervals`;
};

export const getServiceIntervals = async (
    params: GetServiceIntervalsParams,
    options?: RequestInit
): Promise<getServiceIntervalsResponse> => {
    const res = await fetch(getGetServiceIntervalsUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getServiceIntervalsResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getServiceIntervalsResponse;
};

export type updateServiceIntervalsResponse200 = {
    data: ServiceIntervalBatchResponse;
    status: 200;
};

export type updateServiceIntervalsResponse400 = {
    data: void;
    status: 400;
};

export type updateServiceIntervalsResponse500 = {
    data: void;
    status: 500;
};

export type updateServiceIntervalsResponseSuccess = updateServiceIntervalsResponse200 & {
    headers: Headers;
};

export type updateServiceIntervalsResponseError = (
    | updateServiceIntervalsResponse400
    | updateServiceIntervalsResponse500
) & {
    headers: Headers;
};

export type updateServiceIntervalsResponse =
    | updateServiceIntervalsResponseSuccess
    | updateServiceIntervalsResponseError;

export const getUpdateServiceIntervalsUrl = () => `/api/v1/service-intervals`;

export const updateServiceIntervals = async (
    serviceIntervalBatchUpdateRequest: ServiceIntervalBatchUpdateRequest,
    options?: RequestInit
): Promise<updateServiceIntervalsResponse> => {
    const res = await fetch(getUpdateServiceIntervalsUrl(), {
        ...options,
        body: JSON.stringify(serviceIntervalBatchUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: updateServiceIntervalsResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as updateServiceIntervalsResponse;
};
